import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import debounce from 'lodash.debounce';
import {
    Header,
    LabList,
    Search,
    Spinner,
    Pagination,
    Row,
} from '../../components';
import { http } from '../../helpers';
import './styles.scss';

const getInitialPagination = () => ({
    number: 0,
    totalPages: 0,
    first: null,
    last: null,
});

export default function Labs() {
    const navigate = useNavigate();
    const [labs, setLabs] = useState(null);
    const [pagination, setPagination] = useState(getInitialPagination());
    const [fetching, setFetching] = useState(false);
    const [search, setSearch] = useState('');

    const getLabs = (page = 0, searchStr = search) => {
        const relativeUrl = `/case-api/labs?size=10&page=${page || 0}&sort=name,id&search=${searchStr || ''}&archived=false`;
        setFetching(true);
        http.get(relativeUrl)
            .then(({ data }) => {
                setLabs(data.content);
                setPagination({
                    number: data.number,
                    totalPages: data.totalPages,
                    first: data.first,
                    last: data.last,
                });
            })
            .catch((error) => {
                console.warn(error);
            })
            .finally(() => setFetching(false));
    };

    useEffect(() => {
        getLabs(0, search);
    }, []);

    const onChangePage = (page) => {
        getLabs(page, search);
    };

    const onUpdateSearch = debounce((searchStr) => {
        setSearch(searchStr);
        getLabs(0, searchStr);
    }, 500);
    const onAddLab = () => {
        navigate('/create-lab');
    };
    const onDeleteLab = (id) => {
        http.delete(`/case-api/labs/${id}`)
            .then((res) => {
                if (res.status === 200) {
                    getLabs();
                }
            })
            .catch((error) => {
                console.warn(error);
            });
    };
    const onSaveLab = (labToSave) => {
        http.put(`/case-api/labs/${labToSave.id}`, labToSave)
            .then((res) => {
                if (res.status === 200) {
                    getLabs();
                }
            })
            .catch((error) => {
                console.warn(error);
            });
    };

    return (
        <>
            <Header label="Labs" />
            <main className="dashboard-container">
                <Row>
                    <div className="clinic-header">
                        <Search onChange={onUpdateSearch} label="Search lab name" />
                        <i title="Add new lab" role="presentation" className="material-icons fz-50 clickable" onClick={onAddLab}>add_circle</i>
                    </div>
                </Row>
                {
                    fetching && <Spinner type="page" />
                }
                {
                    labs && !labs.length && !fetching
                        ? <p className="text-red text-align-center">No labs found</p>
                        : (
                            <LabList
                                labs={labs}
                                onDeleteLab={onDeleteLab}
                                onSaveLab={onSaveLab}
                            />
                        )
                }
                <Pagination onChangePage={onChangePage} pagination={pagination} />
            </main>
        </>
    );
}
